import React from "react";

import { connect } from "react-redux";

import { signOut } from "app/api/redux/Auth/actions";

import "./styles.scss";
import { withRouter, RouteComponentProps } from "react-router";

interface IProps extends RouteComponentProps {
  signOut: () => any;
  isLoading: boolean;
  isSignFail: boolean;
}

interface IState {
  errors: any;
}

class SignOutPage extends React.PureComponent<IProps, IState> {
  state: IState = {
    errors: []
  };

  componentDidMount() {
    this.props.signOut();
    this.props.history.push("/signin");
  }

  render() {
    return <div>До свидания</div>;
  }
}
const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.isLoading,
    isSignFail: state.auth.isSignFail
  };
};

export default connect(mapStateToProps, {
  signOut
})(withRouter(SignOutPage));
